<div class="ps" [dir]="languageService.direction()" [style.--ps-cols]="steps().length">
    <div class="ps__rail" [class.is-truncated-start]="truncateStart()" [class.is-truncated-end]="truncateEnd()">
        @if (showBand()) {
            <div class="ps__band">
                @for (group of groups(); track group.year) {
                    <button
                        type="button"
                        class="ps__band-cell"
                        [class.is-active]="group.year === selectedYear()"
                        [class.is-selected]="group.year === activeYear()"
                        [class.is-selectable]="yearsSelectable()"
                        [class.is-emphasized]="emphasizeYears()"
                        [style.--ps-span]="group.span"
                        [disabled]="!yearsSelectable()"
                        [title]="group.issue ?? ''"
                        (click)="selectYear(group.year)"
                    >
                        <span class="ps__band-year" [class.has-weight-problem]="group.issue">{{ group.year }}</span>
                    </button>
                }
            </div>
        }

        <div class="ps__track">
            @for (step of railSteps(); track step.id) {
                <button
                    type="button"
                    class="ps__tick"
                    [class.is-active]="step.id === selectedId()"
                    [class.is-in-selected-year]="isYearSelected() && step.year === activeYear()"
                    [style.--ps-x]="step.ratio"
                    (click)="stepSelect.emit(step.id)"
                ></button>
            }

            @if (showPill()) {
                <span class="ps__pill" [style.--ps-x]="selectedRatio()">{{ pill() }}</span>
            }
        </div>

        <div class="ps__labels">
            @for (step of railSteps(); track step.id) {
                <span [class.is-active]="step.id === selectedId()" [class.is-year]="step.year === selectedYear()">{{ step.label }}</span>
            }
        </div>
    </div>
</div>
